import { CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA, CampanhaPedidoResgateState, SET_RESGATES_PAGAR, CampanhasActionTypes, REMOVE_RESGATE, CAMPANHARESGATE_APROVAR, RESET_RESGATES_PAGAR } from "domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgate"
import { DispatchReset, PagedReducer, PagedReducerReset } from "base/src/utils/reducerUtil";
import ValidationResult from "domain/types/global/validationResult";
import { IPagedListResponse } from "domain/types/global/pagedListResponse";
import { CampanhaPedidoResgateResponse } from 'domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgateResponse';

const INITIAL_STATE: CampanhaPedidoResgateState = {
    CampanhaPedidoResgateByCampanha: undefined,
    formData: [],
    mudancaStatus: {} as ValidationResult
};

export function CampanhaPedidoResgateReducer(
    state = INITIAL_STATE,
    action: CampanhasActionTypes
): CampanhaPedidoResgateState {
    switch (action.type) {
        case CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA:
            return PagedReducer(state, "CampanhaPedidoResgateByCampanha", action.payload, "CampanhaPedidoResgateID", CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA)

        case DispatchReset(CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA):
            return PagedReducerReset(state, "CampanhaPedidoResgateByCampanha", {} as IPagedListResponse<CampanhaPedidoResgateResponse>, "CampanhaPedidoResgateID", CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA)

        case SET_RESGATES_PAGAR:
            return { ...state, formData: action.payload as [] };

        case RESET_RESGATES_PAGAR:
            return { ...state, formData: [] };

        case REMOVE_RESGATE:
            return { ...state, formData: state.formData.filter(item => item.CampanhaPedidoResgateID !== action.payload) };
        case CAMPANHARESGATE_APROVAR:
            return { ...state, mudancaStatus: action.payload };
        default:
            return state;
    }
}
